<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <Sidebar :navItems="nav" />
      <main class="main">
        <breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    Header as AppHeader,
    Sidebar,
    Footer as AppFooter,
    Breadcrumb,
} from '../components/admin';
import VolunteersAssociates from "@/views/volunteers_associates/Win.vue";

export default {
    name: 'full',
    components: {
        AppHeader,
        Sidebar,
        AppFooter,
        Breadcrumb,
    },
    data()
    {
        return {
            nav: [],
        };
    },
    created()
    {
        if (this.langInitialized)
        {
            this.initMenu();
        }
    },
    methods: {
        initMenu()
        {
            const me = this;

            this.nav = [
                {
                    name: me.$i18n.t('DASHBOARD'),
                    url: '/dashboard',
                    visible: !!(me.globals.acl.Child && me.globals.acl.Child.instantiate),
                    icon: 'home',
                },
                {
                    name: me.$i18n.t('EVENT'),
                    url: '/event',
                    visible: !!(me.globals.acl.Child && me.globals.acl.Child.instantiate),
                    icon: 'calendar-alt',
                },
                {
                    name: me.$i18n.t('CHILDREN'),
                    icon: 'users',
                    visible: !!(me.globals.acl.Child && me.globals.acl.Child.insertAction),
                    children: [
                        {
                            name: me.$i18n.t('CHILD'),
                            url: '/children/child',
                            visible:
                !!(me.globals.acl.Child && me.globals.acl.Child.insertAction),
                            icon: 'child',
                        },
                        {
                            name: me.$i18n.t('PARENTS'),
                            url: '/children/parents',
                            visible:
                !!(me.globals.acl.Parents && me.globals.acl.Parents.insertAction),
                            icon: 'user-friends',
                        },
                    ],
                },
                {
                    name: me.$i18n.t('THERAPY'),
                    icon: 'syringe',
                    visible:
            !!(me.globals.acl.TherapyType
            && me.globals.acl.TherapyType.insertAction),
                    children: [
                        {
                            name: me.$i18n.t('THERAPYTYPE'),
                            url: '/therapy/therapytype',
                            visible:
                !!(me.globals.acl.TherapyType
                && me.globals.acl.TherapyType.insertAction),
                            icon: 'pills',
                        },
                        {
                            name: me.$i18n.t('WORKTYPE'),
                            url: '/therapy/worktype',
                            visible:
                !!(me.globals.acl.WorkType
                && me.globals.acl.WorkType.insertAction),
                            icon: 'network-wired',
                        },
                        {
                            name: me.$i18n.t('DIAGNOSE'),
                            url: '/therapy/diagnose',
                            visible:
                !!(me.globals.acl.Diagnose
                && me.globals.acl.Diagnose.insertAction),
                            icon: 'network-wired',
                        },
                    ],
                },
                {
                    name: me.$i18n.t('ROOM'),
                    url: '/room',
                    visible: !!(me.globals.acl.Room && me.globals.acl.Room.instantiate),
                    icon: 'building',
                },
                {
                    name: me.$i18n.t('GROUPWAITINGLIST'),
                    url: '/group_waiting_list',
                    visible: !!(me.globals.acl.GroupWaitingList && me.globals.acl.GroupWaitingList.instantiate),
                    icon: 'building',
                },
                {
                    name: me.$i18n.t('WAITLISTINDIVIDUALSESSIONS'),
                    url: '/waitlist_individual_sessions',
                    visible: !!(me.globals.acl.WaitlistIndividualSessions && me.globals.acl.WaitlistIndividualSessions.instantiate),
                    icon: 'building',
                },
                {
                    name: me.$i18n.t('WORKINGGROUP'),
                    url: '/workinggroup',
                    visible: !!(me.globals.acl.WorkingGroups && me.globals.acl.WorkingGroups.instantiate),
                    icon: 'users',
                },
                {
                    name: me.$i18n.t('STATISTICS'),
                    url: '/admin/statistics',
                    visible: !!(me.globals.acl.Statistics && me.globals.acl.Statistics.instantiate),
                    icon: 'chart',
                },
                {
                    name: me.$i18n.t('NOTE'),
                    url: '/note',
                    visible: !!(me.globals.acl.Note && me.globals.acl.Note.instantiate),
                    icon: 'sticky-note',
                },
                {
                    name: me.$i18n.t('VOLUNTEERSASSOCIATES'),
                    url: '/volunteersassociates',
                    visible: !!(me.globals.acl.VolunteersAssociates && me.globals.acl.VolunteersAssociates.instantiate),
                    icon: 'bell',
                },
                {
                    name: me.$i18n.t('NOTIFICATIONS'),
                    url: '/notifications',
                    visible: !!(me.globals.acl.Notifications && me.globals.acl.Notifications.deleteAction && me.globals.companyId != null && me.globals.companyId == 2),
                    icon: 'bell',
                },
                {
                    name: me.$i18n.t('SYSTEM'),
                    icon: 'cog',
                    visible: !!(me.globals.acl.Users && me.globals.acl.Users.deleteAction),
                    children: [
                        {
                            name: me.$i18n.t('ACL'),
                            url: '/system/acl',
                            visible:
                !!(me.globals.acl.AclPrivilages
                && me.globals.acl.AclPrivilages.insertRow.insertAction),
                            icon: 'lock',
                        },
                        {
                            name: me.$i18n.t('TRANSLATOR'),
                            url: '/system/translator',
                            visible:
                !!(me.globals.acl.Translator
                && me.globals.acl.Translator.deleteAction),
                            icon: 'flag',
                        },
                        {
                            name: me.$i18n.t('LANGUAGES'),
                            url: '/system/languages',
                            visible:
                !!(me.globals.acl.TransLang && me.globals.acl.TransLang.deleteAction),
                            icon: 'globe',
                        },
                        {
                            name: me.$i18n.t('SITEPROPS'),
                            url: '/system/siteprops',
                            visible:
                !!(me.globals.acl.SiteProps && me.globals.acl.SiteProps.insertAction),
                            icon: 'wrench',
                        },
                        {
                            name: me.$i18n.t('EMAILTEMPLATES'),
                            url: '/system/emailtemplates',
                            visible:
                !!(me.globals.acl.EmailTemplates
                && me.globals.acl.EmailTemplates.insertAction),
                            icon: 'envelope',
                        },
                        {
                            name: me.$i18n.t('USERCOMPANIES'),
                            url: '/system/usercompanies',
                            visible:
                !!(me.globals.acl.UserCompanies
                && me.globals.acl.UserCompanies.insertAction),
                            icon: 'building',
                        },
                        {
                            name: me.$i18n.t('COMPANYTYPE'),
                            url: '/system/companytype',
                            visible:
                !!(me.globals.acl.CompanyType
                && me.globals.acl.CompanyType.insertAction),
                            icon: 'building',
                        },
                        {
                            name: me.$i18n.t('USERS'),
                            url: '/system/users',
                            visible:
                !!(me.globals.acl.Users && me.globals.acl.Users.deleteAction),
                            icon: 'user',
                        },
                    ],
                },
            ];
        },
    },
    watch: {
        translation()
        {
            this.initMenu();
        },
        langInitialized()
        {
            this.initMenu();
        },
    },
    computed: {
        ...mapGetters(['globals', 'langInitialized', 'translation']),
        name()
        {
            return this.$route.name;
        },
        list()
        {
            return this.$route.matched;
        },
    },
};
</script>
